import React, { useEffect, useState } from 'react';
import { useLoading } from '../context/LoadingProvider';

function CardItem({ imageUrl, title, description, link }) {
  return (
    <div className="card card-hero">
      <img className="card-hero-img" src={imageUrl} alt={title} />
      <div className="card-body">
        <h2 className="card-title-lg">{title}</h2>
        <p className="card-subtitle">{description}</p>
        <div className="card-actions">
          <a className="btn btn-primary" href={link || '#'} target="_blank" rel="noreferrer">Read More</a>
        </div>
      </div>
    </div>
  );
}

function useCards(enabled = true) {
  const [cards, setCards] = useState([]);
  const [loading, setLoading] = useState(enabled);
  const [error, setError] = useState('');
  const { showLoading, hideLoading } = useLoading();

  useEffect(() => {
    if (!enabled) {
      setLoading(false);
      return undefined;
    }

    showLoading();

    const timeoutId = setTimeout(() => {
      try {
        const staticCards = [
          {
            id: '1',
            imageUrl: `${process.env.PUBLIC_URL}/assest/img/weru.png`,
            title: 'Innovation Workshop',
            description: 'Join our upcoming workshop on technological innovation and entrepreneurship. Learn from industry experts and network with fellow innovators.',
            link: '#workshop'
          },
          {
            id: '2',
            imageUrl: `${process.env.PUBLIC_URL}/assest/img/show.png`,
            title: 'Startup Showcase',
            description: 'Discover innovative startups from our hub showcasing their groundbreaking solutions and technologies.',
            link: '#showcase'
          },
          {
            id: '3',
            imageUrl: `${process.env.PUBLIC_URL}/assest/img/gunzert.jpg`,
            title: 'Tech Meetup',
            description: 'Monthly tech meetup featuring discussions on emerging technologies and their impact on local innovation.',
            link: '#meetup'
          },
          {
            id: '4',
            imageUrl: `${process.env.PUBLIC_URL}/assest/img/dtb1.png`,
            title: 'HubIquatous Program',
            description: 'Participate in our innovation challenge and get a chance to win funding for your startup idea.',
            link: '#program'
          }
        ];
        setCards(staticCards);
      } catch (e) {
        setError('Failed to load');
      } finally {
        setLoading(false);
        hideLoading();
      }
    }, 300);

    return () => {
      clearTimeout(timeoutId);
      hideLoading();
    };
  }, [enabled, showLoading, hideLoading]);

  return { cards, loading, error };
}

function Card({ items, eyebrow = "WHAT'S HAPPENING", title = 'Latest at BuniHub', autoScroll = false }) {
  const hasProvidedItems = Boolean(items && items.length);
  const { cards, loading, error } = useCards(!hasProvidedItems);
  const baseData = items && items.length ? items : cards;
  const data = autoScroll ? [...baseData, ...baseData] : baseData;

  if (!items && loading) return null;
  if (!items && error) return <div className="cards-grid">{error}</div>;

  if (autoScroll) {
    return (
      <section className="section-cards" id="news">
        <div className="cards-header">
          <p className="eyebrow">{eyebrow}</p>
          <h2 className="section-title">{title}</h2>
        </div>
        <div className="cards-scroll-wrapper">
          <div className="cards-track">
            {data.map((c, idx) => (
              <div className="cards-track-item" key={`${c.id}-${idx}`}>
                <CardItem imageUrl={c.imageUrl} title={c.title} description={c.description} link={c.link} />
              </div>
            ))}
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className="section-cards" id="news">
      <div className="cards-header">
        <p className="eyebrow">{eyebrow}</p>
        <h2 className="section-title">{title}</h2>
      </div>
      <div className="cards-grid">
        {data.map((c) => (
          <CardItem key={c.id} imageUrl={c.imageUrl} title={c.title} description={c.description} link={c.link} />
        ))}
      </div>
    </section>
  );
}

export default Card;


